// Small filled heart, brand sea-green by default. Used in the footer credit
// in place of the word "love". Pass `label` to keep it accessible (screen
// readers then read "Made with love by …"); omit it for purely decorative use.
export default function HeartIcon({ size = 13, color = '#3F6B5C', label, style }) {
  const a11y = label
    ? { role: 'img', 'aria-label': label }
    : { 'aria-hidden': true, focusable: 'false' };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style} {...a11y}>
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
    </svg>
  );
}
